/** Stable retained-candidate identity shared by results and direct authoring. */
import * as z from 'zod';
import { resultQuoteSchema } from './shopify-study-results-source.js';
const identity = {
    studyId: z.string().min(1).max(256),
    runId: z.string().min(1).max(256),
    analysisId: z.string().regex(/^sha256:[a-f0-9]{64}$/),
};
const dedicated = z.strictObject({
    ...identity,
    source: z.literal('next_tests').optional(),
    batch: z.number().int().nonnegative(),
    candidateIndex: z.number().int().nonnegative(),
});
const synthesis = z.strictObject({
    ...identity,
    source: z.literal('response_phrase_synthesis'),
    synthesisId: z.string().regex(/^sha256:[a-f0-9]{64}$/),
    sourceHash: z.string().regex(/^sha256:[a-f0-9]{64}$/),
    proposalId: z.string().min(1).max(512),
});
export const studyAuthoringNextTestSelectionSchema = z.union([dedicated, synthesis]);
const seed = {
    productId: z.string().min(1),
    sourceRevision: z.number().int().positive(),
    changedFactor: z.string().min(1),
    heldFixed: z.array(z.string()),
    alternatives: z.array(z.string()),
    merchantDecisions: z.array(z.string()),
    evidence: z.array(z.strictObject({ answerRef: z.string(), role: z.enum(['supporting', 'qualifying']) })),
};
export const studyAuthoringNextTestSeedSchema = z.union([
    dedicated.extend(seed),
    synthesis.extend({ ...seed, evidenceExchangeRefs: z.array(z.string()).min(1) }),
]);
/** A proposal remains readable without an available draft handoff. */
export const resultPhraseProposalSchema = z.strictObject({
    id: z.string(),
    title: z.string(),
    hypothesis: z.string(),
    description: z.string(),
    details: z.array(z.string()),
    evidence: z.array(resultQuoteSchema),
    createDraft: z.strictObject({ label: z.string(), selection: studyAuthoringNextTestSelectionSchema }).optional(),
});
//# sourceMappingURL=study-next-test-selection.js.map